var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMoneySend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/money-send"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.194 20.832h-2.137a2.8 2.8 0 01-2.751-2.843.859.859 0 01.853-.852.859.859 0 01.853.853 1.094 1.094 0 001.045 1.136h2.137a.843.843 0 00.8-.887c0-.614-.171-.7-.557-.841l-3.426-1.193a2.331 2.331 0 01-1.705-2.456 2.558 2.558 0 012.5-2.592h2.138a2.8 2.8 0 012.752 2.842.853.853 0 01-1.705 0 1.094 1.094 0 00-1.047-1.137h-2.138a.843.843 0 00-.8.887c0 .614.171.7.557.841l3.427 1.194a2.331 2.331 0 011.706 2.456 2.551 2.551 0 01-2.502 2.592z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M16.001 21.969a.859.859 0 01-.853-.853V10.885a.859.859 0 01.853-.853.859.859 0 01.853.853v10.231a.859.859 0 01-.853.853z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M16 28.221a12.221 12.221 0 110-24.442.859.859 0 01.853.853.859.859 0 01-.853.853A10.516 10.516 0 1026.516 16a.853.853 0 011.705 0A12.231 12.231 0 0116 28.221zM27.369 10.032a.859.859 0 01-.853-.853V5.484h-3.694a.859.859 0 01-.853-.852.859.859 0 01.853-.853h4.547a.859.859 0 01.853.853v4.547a.859.859 0 01-.853.853z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M21.685 11.169a.843.843 0 01-.6-.25.858.858 0 010-1.205l5.682-5.685a.852.852 0 011.205 1.205l-5.685 5.685a.843.843 0 01-.602.25z"
  }))));
}
export default SvgVuesaxOutlineMoneySend;